import React, { Component } from "react";
import TableList from "./CustomTool/TableList";
import { Grid } from "@mui/material";

class PaymentMode extends Component {
  state = {
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      // { id: 'bint_srno', label: 'SR NO' },
      { id: "paymentmodeledger", label: "Payment Mode Ledger" },
      { id: "amount", label: "Amount" },
      { id: "chequeno", label: "Cheque No" },
      { id: "referanceno", label: "Reference No" },
      { id: "transactiondate", label: "Transaction Date" },
      { id: "remark", label: "Remark" },
    ],
    rows: [],
    rowsCount: 0,
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,

    searchData: {
      paymentmodeledger: "",
      amount: "",
      chequeno: "",
      referanceno: "",
      transactiondate: "",
      remark: "",
    },
  };

  //#region Component
  componentDidMount() {
    this.setSearchColumns();
  }
  //#endregion Component
  //#region Handle
  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row) => {
        if (
          searchOpen === true &&
          (this.state.searchData.paymentmodeledger.length === 0 ||
            (row["paymentmodeledger"]
              ? row["paymentmodeledger"]
                  .toString()
                  .toLowerCase()
                  .includes(
                    this.state.searchData.paymentmodeledger.toLowerCase()
                  )
              : false)) &&
          (this.state.searchData.amount.length === 0 ||
            (row["amount"]
              ? row["amount"]
                  .toString()
                  .toLowerCase()
                  .includes(this.state.searchData.amount.toLowerCase())
              : false)) &&
          (this.state.searchData.chequeno.length === 0 ||
            (row["chequeno"]
              ? row["chequeno"]
                  .toString()
                  .toLowerCase()
                  .includes(this.state.searchData.chequeno.toLowerCase())
              : false)) &&
          (this.state.searchData.referanceno.length === 0 ||
            (row["referanceno"]
              ? row["referanceno"]
                  .toString()
                  .toLowerCase()
                  .includes(this.state.searchData.referanceno.toLowerCase())
              : false)) &&
          (this.state.searchData.transactiondate.length === 0 ||
            (row["transactiondate"]
              ? row["transactiondate"]
                  .toString()
                  .toLowerCase()
                  .includes(this.state.searchData.transactiondate.toLowerCase())
              : false)) &&
          (this.state.searchData.transactiondate.length === 0 ||
            (row["transactiondate"]
              ? row["transactiondate"]
                  .toString()
                  .toLowerCase()
                  .includes(this.state.searchData.transactiondate.toLowerCase())
              : false))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {
          // console.log('searchRows on end of Function', searchRows)
        }
      );
    } else {
      this.setState({ searchOpen });
    }
  };

  handleOnSearchInputChange = (e) => {
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen);
        // console.log(this.state.searchData)
      }
    );
  };
  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };
  //#endregion Handle

  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      {
        cType: "CtTxt",
        id: "paymentmodeledger",
        label: "payment Mode Ledger",
        value: this.state.searchData.paymentmodeledger,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "amount",
        label: "Amount",
        value: this.state.searchData.amount,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "chequeno",
        label: "ChequeNo",
        value: this.state.searchData.chequeno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "referanceno",
        label: "Referance No",
        value: this.state.searchData.referanceno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "transactionate",
        label: "Transaction Date",
        value: this.state.searchData.transactionate,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "remark",
        label: "Remark",
        value: this.state.searchData.remark,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      }
    );
    this.setState({ searchColumns });
  };

  render() {
    return (
      <div>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>Payment Mode</b>
          </label>
        </Grid>
        <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          rows={this.state.rows}
          rowsCount={this.state.rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          //   headRowBGColor="#3f51b5"
          //   headRowFontColor='#ffffff'
          //   handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          //   handleOnActionClick={this.handleARDonActionClick}
          actionList={this.state.actionList}
          keyColumn={this.state.keyColumn}
          handleOnSearchChange={this.handleOnSearchChange}
          searchColumns={this.state.searchColumns}
          searchData={this.state.searchData}
          provideSearch={true}
          //   handleOnNewEntryClick={this.handleOnNewEntryClick}
          // toolTipNewEntry='New Product Entry'
        />
      </div>
    );
  }
}

export default PaymentMode;
